import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { IonButton, IonIcon, modalController } from "@ionic/vue";
import { computed, ref } from "vue";
import { chevronBack } from "ionicons/icons";

import ModalControllerBase from "@/components/modal/modalControllerModals/ModalControllerBase.vue";
import CustomHeader from "@/components/basePageElements/CustomHeader.vue";
import InformationInterface from "@/components/modal/InformationInterface.vue";
import ButtonNavigations from "@/components/button/ButtonNavigations.vue";

import { useNotificationStore } from "@/stores/notification";

import { isApp } from "@/functions/enviroment";

import { useInformationModal } from "@/composables/viewFunctions/useInformationModal";

import { NewsDisplayProps } from "@/types/props";
import { Information } from "@/types/notification";
import { ProductMaster } from "@/types/supplier";


export default /*@__PURE__*/_defineComponent({
  __name: 'NewsModal',
  props: {
    information: {},
    productSuggestion: { type: Boolean },
    noButtons: { type: Boolean },
    noAutoSelect: { type: Boolean }
  },
  setup(__props: any) {

const props = __props

const { addInformationProductToList } = useInformationModal(props.information)
const notificationStore = useNotificationStore()

const currentInformation = ref<Information>(props.information)

const isButtonBack = computed<boolean>(() => notificationStore.currentInformationIndex > 0)
const isButtonForward = computed<boolean>(() => notificationStore.currentInformationIndex < notificationStore.productSuggestion.data.length - 1)

const addToList = async (params: { product: ProductMaster, amount: number }): Promise<void> => {
    if (!params.product) return
    await addInformationProductToList(params.product, params.amount, props.noAutoSelect, currentInformation.value.id)
}

const goBack = (): void => {
    if (isButtonBack.value && props.productSuggestion) {
        notificationStore.currentInformationIndex -= 1
        currentInformation.value = notificationStore.findProductSuggestion()
    }
}

const goFoward = (): void => {
    if (isButtonForward.value && props.productSuggestion) {
        notificationStore.currentInformationIndex += 1
        currentInformation.value = notificationStore.findProductSuggestion()
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalControllerBase, { contentClass: "light-light-background purple-purple-color news-safe-area-bottom" }, {
    header: _withCtx(() => [
      _createVNode(CustomHeader, {
        "back-button": "",
        title: _ctx.$t(`titleRoute.${__props.productSuggestion ? 'suggestion' : 'news'}`)
      }, {
        start: _withCtx(() => [
          _createVNode(_unref(IonButton), {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(modalController).dismiss())),
            class: "purple-light-color"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonIcon), { icon: _unref(chevronBack) }, null, 8, ["icon"]),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('button.back')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["title"])
    ]),
    default: _withCtx(() => [
      (!_unref(isApp)() && __props.productSuggestion && !__props.noButtons)
        ? (_openBlock(), _createBlock(ButtonNavigations, {
            key: 0,
            "is-button-back": isButtonBack.value,
            "is-button-forward": isButtonForward.value,
            onFoward: goFoward,
            onBack: goBack
          }, null, 8, ["is-button-back", "is-button-forward"]))
        : _createCommentVNode("", true),
      _createVNode(InformationInterface, {
        information: currentInformation.value,
        "item-placeholder": __props.productSuggestion,
        onAdd: addToList
      }, null, 8, ["information", "item-placeholder"])
    ]),
    _: 1
  }))
}
}

})